module.exports = __webpack_public_path__ + "img/title-min.5fb6da96.svg";